import React, { Component } from 'react';
import {
  WithSnackbarProps,
  withSnackbar,
} from 'notistack';
import {
  inject,
  observer,
} from 'mobx-react';
import {
  reaction,
  IReactionDisposer,
} from 'mobx';
import IconButton from '@material-ui/core/IconButton';
import NotifierStore from '../../stores/notifier-store';

interface NotificationOptions {
  action?: (key: string | any) => React.ReactNode;
  onClose?: () => void;
  [key: string]: any; // For any additional options
}

interface Notification {
  key: string;
  message: string;
  options?: NotificationOptions;
}

interface Props extends WithSnackbarProps {
  notifierStore?: NotifierStore;
}

@inject('notifierStore')
@observer
class Notifier extends Component<Props> {
  private displayed: string[] = [];
  private disposeReaction: IReactionDisposer | null = null;

  private storeDisplayed = (id: string): void => {
    this.displayed = [...this.displayed, id];
  };

  private processNotifications = (): void => {
    const { notifierStore, enqueueSnackbar, closeSnackbar } = this.props;

    if (!notifierStore || !enqueueSnackbar || !closeSnackbar) {
      return;
    }

    const { notifications = [] } = notifierStore;

    notifications.forEach((notification: Notification) => {
      if (this.displayed.includes(notification.key)) {
        return;
      }

      const action = (key: string) => (
        <IconButton
          onClick={() => {
            closeSnackbar(key);
          }}
          size="small"
        >
          <i className="fa fa-remove" />
        </IconButton>
      );

      const options: NotificationOptions = {
        ...notification.options,
        action,
      };

      enqueueSnackbar(notification.message, options);
      this.storeDisplayed(notification.key);
      notifierStore.removeSnackbar(notification.key);
    });
  };

  componentDidMount(): void {
    if (this.props.notifierStore) {
      this.disposeReaction = reaction(
        () => this.props.notifierStore!.notifications.length,
        this.processNotifications,
        { fireImmediately: true },
      );
    }
  }

  componentWillUnmount(): void {
    if (this.disposeReaction) {
      this.disposeReaction();
    }
  }

  render(): null {
    return null;
  }
}

export default withSnackbar(Notifier);
